import { useEffect, useState } from 'react'
import type { Mismatch } from '../types'
import { fetchHistory } from '../lib/api'
import { MismatchTable } from '../components/MismatchTable'
import { ExportButtons } from '../components/ExportButtons'
import { useBrandFilter } from '../lib/brand'

export function History() {
  const [brand] = useBrandFilter()
  const [rows, setRows] = useState<Mismatch[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    ;(async () => {
      try {
        setRows(null)
        setRows(await fetchHistory(200))
      } catch (e) {
        setError((e as Error).message)
      }
    })()
  }, [brand])

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">History</h1>
          <p className="text-sm text-slate-400">
            Last 200 resolved or auto-resolved mismatches.
          </p>
        </div>
        <ExportButtons name="history" rows={rows as unknown as Record<string, unknown>[] | null} />
      </div>
      {error && (
        <div className="border border-red-500/40 bg-red-500/10 text-red-200 rounded px-3 py-2 text-sm">
          {error}
        </div>
      )}
      {rows && <MismatchTable rows={rows} readOnly showBrand={brand === 'ALL'} />}
    </div>
  )
}
